import { useState } from 'react';
import Column from './Column';

export default function Weekly({
  getDayName,
  getEventsForDay,
  trads,
  lang,
  demoMode,
  onEventClick,
  onAddEvent,
}) {
  const [mobileView, setMobileView] = useState(0); // 0: Mon-Tue, 1: Wed-Thu, 2: Fri-Sat, 3: Sun
  const tIndex = trads?.index || {};

  // Backend convention: 0=Monday, 1=Tuesday, ..., 6=Sunday
  const orderedDays = [0, 1, 2, 3, 4, 5, 6];
  const mobileGroups = [[0, 1], [2, 3], [4, 5], [6]];

  return (
    <div className="mb-8">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">
          <span>
            {tIndex.weeklyRecurringEvents || 'Weekly recurring events'}
          </span>
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          {tIndex.weeklyRecurringEventsDescription ||
            'Plan repetitive weekly reminders.'}
        </p>
      </div>

      <div className="desktop-grid mb-4">
        {orderedDays.map((dayIndex) => (
          <Column
            key={dayIndex}
            dayIndex={dayIndex}
            dayName={getDayName(dayIndex)}
            events={getEventsForDay(dayIndex)}
            trads={trads}
            lang={lang}
            demoMode={demoMode}
            onEventClick={onEventClick}
            onAddEvent={onAddEvent}
          />
        ))}
      </div>

      <div className="mobile-grid">
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={() => setMobileView((v) => Math.max(0, v - 1))}
            disabled={mobileView === 0}
            data-testid="mobile-nav-prev"
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <span className="text-sm font-medium text-gray-600">
            {mobileGroups[mobileView].map((d) => getDayName(d)).join(' - ')}
          </span>
          <button
            onClick={() => setMobileView((v) => Math.min(3, v + 1))}
            disabled={mobileView === 3}
            data-testid="mobile-nav-next"
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>

        <div className="grid gap-2 grid-cols-2">
          {mobileGroups[mobileView].map((dayIndex) => (
            <Column
              key={dayIndex}
              dayIndex={dayIndex}
              dayName={getDayName(dayIndex)}
              events={getEventsForDay(dayIndex)}
              trads={trads}
              lang={lang}
              demoMode={demoMode}
              onEventClick={onEventClick}
              onAddEvent={onAddEvent}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
